<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
<mat-menu #notesMenu="matMenu">
  <button class="flex w-52 justify-between gap-4 font-medium text-text-primary" (click)="onToggleEditMode()">
    <span>{{ (inEditMode() ? 'notes_menu_cancel_edit' : 'notes_menu_edit_note') | translate }}</span>
    <svg-icon class="shrink-0" size="md" [key]="inEditMode() ? 'px-12-x' : 'px-24-pencil'"></svg-icon>
  </button>
  <button class="flex justify-between gap-4 font-medium text-states-red" (click)="onDeleteNoteClick()">
    <span>{{ 'notes_menu_delete_note' | translate }}</span>
    <svg-icon class="shrink-0 text-states-red" size="md" key="px-16-delete"></svg-icon>
  </button>
</mat-menu>
<div class="mx-10 flex h-full flex-col rounded-3xl text-text-secondary transition-[margin] duration-300">
  <div
    (click)="emptyAreaClick($event)"
    class="mb-4 flex items-center justify-between gap-3 border-b-2 border-background-light-grey pb-2 transition-opacity duration-300"
  >
    <div class="flex flex-1 items-center gap-1">
      <div class="flex">
        <lib-input [border]="false" [formControl]="noteTitleFormControl" [placeholder]="'express_notes_add_patient_name' | translate">
          <svg-icon class="text-primary-blue" key="px-24-dentist" size="md" leftIcon></svg-icon>
        </lib-input>
      </div>
    </div>
    <div>
      <div class="flex flex-1 justify-center text-h5 font-normal text-text-light">
        {{ note().date | date: dateTimeFormat }}
      </div>
    </div>
    <div class="flex flex-1 items-center justify-end">
      <button
        cdkOverlayOrigin
        #copyNoteButton="cdkOverlayOrigin"
        (click)="onCopyNote($event)"
        class="btn-primary flex h-10 items-center justify-center gap-1.5 rounded-2xl"
      >
        {{ (isNoteCopied() ? 'express_notes_note_copied' : 'express_notes_copy_note') | translate }}
        <svg-icon
          [@iconTransition]="isNoteCopied() ? 'copied' : 'default'"
          [key]="isNoteCopied() ? 'px-16-check' : 'px-24-layers'"
          size="sm"
          class="text-text-white"
        ></svg-icon>
      </button>
      <button
        #contextMenuTrigger="matMenuTrigger"
        (click)="menuClicked($event)"
        class="flex h-7 w-7 items-center justify-center"
        [matMenuTriggerFor]="notesMenu"
      >
        <svg-icon key="px-16-more" size="sm" class="text-text-tertiary"></svg-icon>
      </button>
    </div>
  </div>
  <div class="flex flex-col overflow-auto">
    @if (inEditMode()) {
      <lib-textarea-with-ai
        [formControl]="noteContentFormControl"
        [contextMenuHeaderConfig]="contextMenuHeaderConfig"
        [contextMenuConfig]="contextMenuConfig"
        [autoSave]="true"
        [isSaved]="isNoteSaved()"
        [isSaving]="isNoteSaving()"
        [enableVoiceTyping]="true"
        [enableIosMic]="true"
        [closeButtonDisabled]="false"
        (closeClicked)="onToggleEditMode()"
        (enhanceUsed)="onEnhanceUsed($event)"
        (voiceTypingStatusChange)="onVoiceTypingStatusChange($event)"
      ></lib-textarea-with-ai>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="copyNoteButton"
  [cdkConnectedOverlayOpen]="isCopyOverlayOpen()"
  [cdkConnectedOverlayPositions]="overlayPositionStrategy"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="['opacity-0']"
  [cdkConnectedOverlayOffsetY]="16"
  (backdropClick)="closeCopyOverlay()"
>
  <div class="flex w-[340px] flex-col items-center gap-4 rounded-[28px] bg-background-white p-6 shadow-card">
    <!-- Green checkmark circle -->
    <div class="border-1 rounded-full border border-dashed border-secondary-green p-[1px]">
      <div class="flex aspect-square h-9 w-9 items-center justify-center rounded-full bg-background-green/20">
        <svg-icon key="px-16-check" class="text-secondary-green" size="sm"></svg-icon>
      </div>
    </div>

    <!-- Heading -->
    <h3 class="typo-h4-medium text-center text-text-primary">
      {{ 'express_notes_note_copied_heading' | translate }}
    </h3>

    <!-- Illustration placeholder -->
    <div class="h-32">
      <img class="h-full" src="/assets/images/copy-note.svg" alt="Copy note illustration" />
    </div>

    <!-- Description -->
    <p class="typo-h5-book text-center text-text-secondary">
      {{ 'express_notes_note_copied_description' | translate }}
    </p>

    <!-- Checkbox and Got it button -->
    <div class="flex w-full items-center justify-between gap-4">
      <div class="flex items-center gap-2">
        <lib-checkbox [checked]="doNotShowAgainChecked()" (click)="onDoNotShowAgainChange(!doNotShowAgainChecked())"></lib-checkbox>
        <span class="typo-h4-light text-text-secondary">
          {{ 'express_notes_note_copied_do_not_show' | translate }}
        </span>
      </div>
      <button (click)="onGotItClick()" class="btn-primary h-10 rounded-2xl px-6">
        {{ 'express_notes_note_copied_got_it' | translate }}
      </button>
    </div>
  </div>
</ng-template>
